import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  getAspectCall,
  getAspectColorsCall,
  postAspectGenerateCall,
  putAspectSaveCall,
  getAspectForAppCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getAspectCall.saga,
  getAspectColorsCall.saga,
  postAspectGenerateCall.saga,
  putAspectSaveCall.saga,
  getAspectForAppCall.saga,
];

export function* aspectRootSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
